import { configureStore as createReduxStore } from '@reduxjs/toolkit';
import rootReducer from './reducers'; // Import your combined reducers

// Define any additional middleware you want to include
const additionalMiddlewares = [];

// Use configureStore from Redux Toolkit
export const store = createReduxStore({
  reducer: rootReducer,
  middleware: (gdm) =>
    gdm({
      thunk: true,
      immutableCheck: false,
      serializableCheck: false,
    }).concat(additionalMiddlewares),
  devTools: true
});
